module.exports = __webpack_public_path__ + "static/fonts/DINProMedium.0acc75de.ttf";